import { useEffect, useState } from 'react';
import { viewerIframeId } from './services/stp-viewer.service';
import globalStyles from '../global-styles.module.scss';
import styles from './stp-viewer.module.scss';
import classNames from 'classnames';

export interface IStpViewerInput {
    proto: any;
}

const StpViewer: React.FC<IStpViewerInput> = ({ proto }) => {
    const [core, setCore] = useState<any>();
    const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

    const getInnerHtml = (): string => {
        let innerHtml = '<div id="canvasesContainer" style="width: 100%; height: 100%"></div>';

        innerHtml += `<script type="text/javascript" src="/lib/jquery-2.1.3.js"></script>`;
        innerHtml += '<script type="text/javascript" src="/lib/jquery-ui-1.11.4.js"></script>';
        innerHtml += `
          <script type="text/javascript">
                    window.afterSceneCreatedCallback = function () {
                        ProtoBuf.load("/stp-viewer/stp/proto/ItemModel.proto",
                        null,
                        function (error, root) {
                            protoBuilder = {};
                            protoBuilder.ItemModel = root.lookup("ItemModel");
                            var b64Length = ProtoBuf.util.base64.length('${proto}');
                            var outputBuffer = new Uint8Array(b64Length);
                            ProtoBuf.util.base64.decode('${proto}', outputBuffer, 0);
                            var result = protoBuilder.ItemModel.decode(outputBuffer);
                            for (var i = 0; i < result.parts.length; i++) {//result.parts.length
                                var part = result.parts[i].geometry;
                                var vertices = new Float32Array(part.position);
                                var indices = new Uint16Array(part.index);
                                var color = new THREE.Vector3(part.color[0], part.color[1], part.color[2]);
                                var geometry = new THREE.BufferGeometry();
                                geometry.addAttribute('position', new THREE.BufferAttribute(vertices, 3));
                                geometry.setIndex(new THREE.BufferAttribute(indices, 1));
                                geometry.computeVertexNormals();

                                var material = new VIEW3D.materials.Metal({
                                    diffuseColor: color
                                });
                            material.side = THREE.DoubleSide;
                            var mesh = new THREE.Mesh(geometry, material);
                            CORE.constructionView3D.children.push(mesh);
                        }

                        var dirLight = new THREE.DirectionalLight(0xffffff, 1);
                        dirLight.position.set(1000, 1200, 500);
                        scene.add(dirLight);

                        render(2);
                        CORE.view3D.cameraControl.zoomAll();
                    });
                };

                console.log("CONSTRUCTION VIEWER preloader: Begin");
                window.viewerLoadingStart = performance.now();
                console.log("CONSTRUCTION VIEWER preloader: Trying to load loader.js");
                    $.getScript("/stp-viewer/js/loader.js")
                    .done(function (/*script, textStatus*/) {
                        $('#canvasesContainer')
                            .constructionViewer({
                        rootPath: "/stp-viewer/",
                                disableLoadAndSave: true,
                                loadResources: true,
                                showObjectList: false,
                                showToolbar: false,
                                demoMode: false,
                                useOrthographicProjection: true,
                                height: '500px',
                                hideWorkplane : true
                            });
                })
                    .fail(function (jqxhr, settings, exception) {
                    console.error("CONSTRUCTION VIEWER preloader: loader.js loading failed, error: " + exception);
                });
            </script>
        `;
        return innerHtml;
    };

    const propagateCore = (ifrm: any) => {
        const core = ifrm.CORE;
        setCore(core);
        core.isFullscreen$.subscribe((value: boolean) => {
            setIsFullscreen(value);
        });
    };

    const initIFrame = (): void => {
        const innerHtml: string = getInnerHtml();
        let ifrm = document.getElementById(viewerIframeId) as any;
        ifrm = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
        ifrm.document.open();
        ifrm.document.write(innerHtml);
        ifrm.document.close();
        (window as any).CORELoadedCallback = function () {
            propagateCore(ifrm);
        };
    };

    useEffect(() => {
        initIFrame();
    }, []);

    return (
        <div className={classNames(globalStyles.h_100, globalStyles.w_100)}>
            <iframe
                id={viewerIframeId}
                className={`${classNames(globalStyles.h_100, globalStyles.w_100)} ${isFullscreen ? styles.i_frame_full_screen : ''}`}
            ></iframe>
        </div>
    );
};
export default StpViewer;
